import { Link } from "react-router-dom"
import { useSidebar } from "@/components/ui/sidebar"
import AceHorizonLogo from "@/assets/Acehorizon_logo.svg"
import AceHorizonLogoOrbit from "@/assets/Acehorizon_logo_orbit.svg"

export function TeamSwitcher() {
  const { state } = useSidebar()
  const isCollapsed = state === "collapsed"
  
  return (
    <div className={`flex items-center justify-center h-16 ${isCollapsed ? 'p-1' : 'p-2'}`}>
      <Link to="/" className="block">
        <img 
          src={isCollapsed ? AceHorizonLogoOrbit : AceHorizonLogo} 
          alt="AceHorizon"
          className={`object-contain cursor-pointer hover:opacity-80 transition-all duration-200 ${
            isCollapsed ? "h-11 w-11 !min-h-[44px] !min-w-[44px]" : "h-14 w-auto"
          }`}
          style={isCollapsed ? { height: '44px', width: '44px' } : undefined}
        />
      </Link>
    </div>
  )
}
